import React from "react";
import ReactSlidingPane from "react-sliding-pane";
import moment from "moment";
import Line from "../../../Line/Line";
import attendaceStatus from "../../../../utils/Attendance/attendanceStatus";
import { ATTENDANCE_ACTIVITY } from "../../../../redux/constants/actvityType";

const AttendanceDetailsSlidingPanel = ({ open, close, isProcessAttendance }) => {
const data = isProcessAttendance;

  const statusLabel =
    attendaceStatus.find((status) => status.value === data?.attendance_status_id)
      ?.label || "-";

  const sortedActivities = [...(data?.activity || [])]
    .filter((act) => act?.time)
    .sort((a, b) => moment.utc(a.time).diff(moment.utc(b.time)));

  const firstClockIn = sortedActivities.find((act) => act.activity_type === ATTENDANCE_ACTIVITY.CLOCK_IN);
  const lastClockOut = [...sortedActivities].reverse().find((act) => act.activity_type === ATTENDANCE_ACTIVITY.CLOCK_OUT);

  return (
    <ReactSlidingPane isOpen={open} onRequestClose={close} width="480px">
      <div className="text-black">
        <div className="flex justify-between px-5 py-3">
          <span className="font-medium text-base">Attendance Details</span>
          <button onClick={close} className="text-blue-600">Close</button>
        </div>
        <Line />

        <div className="px-5 flex flex-col gap-3">
          <div className="flex justify-between">
            <div className="flex flex-col gap-1 text-gray-600">
              <ol>Attendance Date</ol>
              <ol>Attendance Status</ol>
              <ol>Shift Duration</ol>
              <ol>Total Leave Hours</ol>
              <ol>First Clock-In</ol>
              <ol>Last Clock-Out</ol>
            </div>

            <div className="flex flex-col gap-1">
              <ol>{data?.attendanceDate || "-"}</ol>
              <ol>
                <span className="status status--green">{statusLabel}</span>
              </ol>
              <ol>{data?.shiftDuration ?? "-"} Hrs</ol>
              <ol>{data?.totalLeaveHours ?? "0"} Hrs</ol>
              <ol>{firstClockIn ? moment.utc(firstClockIn.time).format("hh:mm A") : "-"}</ol>
              <ol>{lastClockOut ? moment.utc(lastClockOut.time).format("hh:mm A") : "-"}</ol>
            </div>
          </div>

          <div className="mt-3">
            <h3 className="font-medium text-base">All Clock Activities</h3>
            <div className="flex justify-between text-sm text-gray-700 pt-2">
              <div className="flex flex-col">
                <strong>Clock-Ins</strong>
                {(data?.activity || []).filter(a => a.activity_type === 1).map((item, i) => (
                  <span key={`in-${i}`}>{moment.utc(item.time).format("hh:mm A")}</span>
                ))}
              </div>
              <div className="flex flex-col">
                <strong>Clock-Outs</strong>
                {(data?.activity || []).filter(a => a.activity_type === 2).map((item, i) => (
                  <span key={`out-${i}`}>{moment.utc(item.time).format("hh:mm A")}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ReactSlidingPane>
  );
};

export default AttendanceDetailsSlidingPanel;
